import { combineSlices } from "@reduxjs/toolkit";
import {
  createPasswordSlice,
  forgotSlice,
  ownerSlice,
  signUpSlice,
  tldSlice,
  verifyEmailSlice,
  workspacesSlice
} from "./slices";

const accountSlice = combineSlices(
  createPasswordSlice,
  forgotSlice,
  ownerSlice,
  signUpSlice,
  tldSlice,
  verifyEmailSlice,
  workspacesSlice
);

export default accountSlice;
